import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { ISubCategoryDetailResponse, ISubCategoryDetailResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useSubCategoryDetailAPI = () => {
  const [subCategoryDetail, setSubCategoryDetail] = useState<ISubCategoryDetailResponseData>({
    subcategory_id: "",
    subcategory_name: "",
    subcategory_tagging: "",
    emr_search: "",
    category_id: "",
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(INVENTORY_MODULE?.SUB_CATEGORY_DETAIL?.baseURL + `?subcategory_id=${id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ISubCategoryDetailResponse>) => {
            if (res.data.status === true) {
              setSubCategoryDetail(res.data.data);
            } else {
              setSubCategoryDetail(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setSubCategoryDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, subCategoryDetail };
};
